import { Controller } from 'stimulus';

import * as events from '@core/core/utils/events';

export default class extends Controller {
  static targets = ["input", "list", "item"]

  connect() {
    this.filter = events.debounce(this.filter.bind(this), 100);
  }

  filter() {
    const query = this.inputTarget.value.toLowerCase()

    this.itemTargets.forEach((item) => {
      const name = item.dataset.name
      item.hidden = !name.includes(query)
    })
  }
}

